import React from "react";
import { ChangesTable } from "../accounting/entry/ChangesTable.js";
import { useTemplate } from "./TemplateProvider.js";

/**
 * Renders table with template changes for the current inputs.
 */
export const TemplateChanges = () => {
  const { entry } = useTemplate();
  if (!entry) {
    return null;
  }

  return <ChangesTable entry={entry} />;
};
